<main class="flex justify-content-center">
  <div class="content">
    <div class="text-center w-12 my-5">
      <h1>Published validations</h1>
      <p>
        The QA4SM validations below have been published by their owners to
        <a
          target="_blank"
          href="https://zenodo.org/"
          rel="noreferrer"
          class="font-semibold"
          >Zenodo</a
        >
        and can be referenced with a
        <a
          class="font-semibold"
          target="_blank"
          href="https://www.doi.org/"
          rel="noreferrer"
          >DOI</a
        >.
      </p>
      @if (totalRecords$ | async; as total) {
        <div>{{ total }} published validations found.</div>
      } @else {
        <div>0 published validations found.</div>
      }
    </div>

    <!-- Filters -->
    <form [formGroup]="filterForm" class="flex flex-row flex-wrap gap-3 my-5">
      <div class="flex flex-column">
        <p-floatLabel>
          <p-date-picker
            id="dateFilter"
            selectionMode="range"
            dateFormat="yy-mm-dd"
            formControlName="dateRange"
            [showIcon]="true"
          >
          </p-date-picker>
          <label for="dateFilter">Choose date range</label>
        </p-floatLabel>
      </div>

      <div class="flex flex-column">
        <p-floatLabel>
          <input
            id="nameFilter"
            type="text"
            pInputText
            formControlName="name"
          />
          <label for="nameFilter">Search by name</label>
        </p-floatLabel>
      </div>

      <div class="flex flex-column">
        <p-floatLabel>
          <input
            id="datasetFilter"
            type="text"
            pInputText
            formControlName="dataset"
          />
          <label for="datasetFilter">Search by dataset</label>
        </p-floatLabel>
      </div>
    </form>

    <!-- Table -->
    <p-table
      [value]="rows$ | async"
      [paginator]="true"
      [rows]="20"
      [lazy]="true"
      [loading]="loading$ | async"
      [totalRecords]="(totalRecords$ | async) || 0"
      (onPage)="onPageChange($event)"
      (onSort)="onSortChange($event)"
      sortMode="single"
      [sortField]="'start_time'"
      [sortOrder]="-1"
      [styleClass]="'p-datatable-sm p-datatable-striped qa-validations-table'"
    >
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center p-5">
            <div class="flex flex-column align-items-center gap-2">
              <i
                class="pi pi-search-plus"
                style="font-size: 2rem; color: var(--text-color-secondary)"
              ></i>
              <span class="font-semibold text-xl">No validations found</span>
              <p class="muted">Try adjusting your filters.</p>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="start_time">
            Date<p-sortIcon field="start_time"></p-sortIcon>
          </th>

          <th pSortableColumn="name_tag">
            Name<p-sortIcon field="name_tag"></p-sortIcon>
          </th>

          <th>Datasets</th>

          <th pSortableColumn="spatial_reference_dataset">
            Spatial reference<p-sortIcon
              field="spatial_reference_dataset"
            ></p-sortIcon>
          </th>

          <th>DOI</th>

          <th>Pin</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData>
        <tr
          class="clickable-row"
          (click)="ViewResults(rowData)"
          tabindex="0"
          (keydown.enter)="ViewResults(rowData)"
          [pTooltip]="'View results'"
          tooltipPosition="top"
        >
          <td>
            {{ rowData.start_time | date: "yyyy-MM-dd" }}
          </td>
          <td class="name-cell">
            {{ rowData.name_tag || "(no name)" }}
          </td>
          <td>
            @if (rowData.datasetsDisplay?.length) {
              @for (d of rowData.datasetsDisplay; track d) {
                <div class="dataset-line">
                  <strong>{{ d.dataset }}</strong>
                  <span class="muted">
                    — {{ d.version }}, {{ d.variable }}
                    @if (d.unit) {
                      <span>[{{ d.unit }}]</span>
                    }
                  </span>
                </div>
              }
            } @else {
              —
            }
          </td>
          <td>
            @if (rowData.spatialReferenceDisplay) {
              <div class="dataset-line">
                <strong>{{ rowData.spatialReferenceDisplay.dataset }}</strong>
                <span class="muted">
                  — {{ rowData.spatialReferenceDisplay.version }}
                </span>
              </div>
            } @else {
              —
            }
          </td>
          <td class="doi-cell">
            @if (rowData.doi) {
              <a
                class="doilink"
                [href]="'https://doi.org/' + rowData.doi"
                target="_blank"
                rel="noreferrer"
              >
                {{ rowData.doi }}
              </a>
            }
            @if (!rowData.doi) {
              <span>—</span>
            }
          </td>

          <td class="pin-cell">
            @if (isLogged$ | async) {
              <button
                pButton
                type="button"
                [icon]="isPinned(rowData) ? 'pi pi-times' : 'pi pi-plus'"
                class="p-button-text"
                [pTooltip]="
                  isPinned(rowData) ? 'Unpin validation' : 'Pin validation'
                "
                tooltipPosition="left"
                [ngClass]="{ 'p-button-danger': isPinned(rowData) }"
                (click)="onTogglePin(rowData, $event)"
              ></button>
            } @else {
              <span class="muted">—</span>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>

    @if (dataFetchError) {
      <div class="text-center w-12 my-2">
        <qa-error></qa-error>
      </div>
    }
  </div>
</main>
